/**
 * Sales tax applied at checkout. Default 8.25% = Lake Zurich, IL general merchandise
 * (6.25% state + 1% village + 1% RTA). Override with `VITE_SALES_TAX_RATE` (decimal, e.g. 0.0825).
 * This is an estimate: qualifying grocery food is taxed at a lower rate, and items are not yet
 * flagged food / non-food, so one rate is applied to the whole cart.
 */
const DEFAULT_RATE = 0.0825

function readRate(): number {
  const raw = Number(import.meta.env.VITE_SALES_TAX_RATE)
  return Number.isFinite(raw) && raw >= 0 && raw < 1 ? raw : DEFAULT_RATE
}

export const SALES_TAX_RATE = readRate()

/** e.g. "8.25%" */
export const SALES_TAX_LABEL = `${+(SALES_TAX_RATE * 100).toFixed(3)}%`

/** Tax on a subtotal, rounded to the cent. */
export function salesTaxFor(subtotal: number): number {
  return Math.round(subtotal * SALES_TAX_RATE * 100) / 100
}
